var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForBabies = function SvgForBabies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#for-babies_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5DD927",
    d: "M4.34.716 8 6h4.5V4.75c0-.966.784-1.75 1.75-1.75h1c.416 0 .75.334.75.75s-.334.75-.75.75h-1a.25.25 0 0 0-.25.25V7c0 .875-.19 1.738-.553 2.534a6.5 6.5 0 0 1-1.547 2.11 7 7 0 0 1-2.266 1.378 7.5 7.5 0 0 1-5.268 0A7 7 0 0 1 2.1 11.644a6.5 6.5 0 0 1-1.547-2.11A6.1 6.1 0 0 1 0 7V6h.003A6.99 6.99 0 0 1 3.093.44c.416-.277.963-.134 1.248.276M2.5 13a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m7.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-8.247-6q.071.21.166.413a5 5 0 0 0 1.193 1.621 5.6 5.6 0 0 0 1.785 1.085A6 6 0 0 0 7.003 12c.725 0 1.438-.128 2.106-.381a5.6 5.6 0 0 0 1.785-1.085 5.1 5.1 0 0 0 1.194-1.621q.091-.204.165-.413.17-.489.225-1H1.528q.057.511.225 1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "for-babies_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgForBabies;